import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UsersPage as MembersInner } from "./Users";
import { TeamsPage as TeamsInner } from "./Teams";

type Tab = "members" | "teams";

/** Merged Users page. Members + invites on one tab, Teams on another. */
export function UsersShell() {
  const location = useLocation();
  const navigate = useNavigate();

  const initial: Tab = location.pathname.endsWith("/teams") || location.search.includes("tab=teams") ? "teams" : "members";
  const [tab, setTab] = useState<Tab>(initial);

  function switchTab(next: Tab) {
    setTab(next);
    const base = "/users";
    navigate(next === "teams" ? `${base}?tab=teams` : base, { replace: true });
  }

  return (
    <>
      <div className="sg-subnav">
        <button
          type="button"
          className={`sg-subnav-item${tab === "members" ? " active" : ""}`}
          onClick={() => switchTab("members")}
        >
          Members
        </button>
        <button
          type="button"
          className={`sg-subnav-item${tab === "teams" ? " active" : ""}`}
          onClick={() => switchTab("teams")}
        >
          Teams
        </button>
      </div>
      {tab === "members" ? <MembersInner /> : <TeamsInner />}
    </>
  );
}
